import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#dc0100",
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        elevation8: {
          boxShadow: "0px 5px 5px -3px rgb(255 0 0 / 20%), 0px 8px 10px 1px rgb(255 0 0 / 14%), 0px 3px 14px 2px rgb(255 0 0 / 12%)",
        },
      },
    },
  },
});

export default theme;